import { Dropdown } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { FiGlobe } from "react-icons/fi";

export const languages = {
  "en-US": { name: "English", flag: "🇺🇸" },
  "en-US-cute": { name: "Koala", flag: "🐨" },
  // "es-ES": { name: "Español", flag: "🇪🇸" },
  // "fr-FR": { name: "Français", flag: "🇫🇷" },
  "zh-CN": { name: "中文", flag: "🇨🇳" },
  // "ja-JP": { name: "日本語", flag: "🇯🇵" },
};

// es: { name: "Español", flag: "🇪🇸" },
// fr: { name: "Français", flag: "🇫🇷" },
// de: { name: "Deutsch", flag: "🇩🇪" },
// Add this component inside the Header component
const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  return (
    <Dropdown align="end" className="ms-2">
      <Dropdown.Toggle variant="light" className="d-flex align-items-center">
        <FiGlobe className="me-2" />
        {languages[i18n.language]?.flag || "🌐"}
      </Dropdown.Toggle>
      <Dropdown.Menu>
        {Object.entries(languages).map(([code, lang]) => (
          <Dropdown.Item key={code} active={i18n.language === code} onClick={() => i18n.changeLanguage(code)}>
            <span className="me-2">{lang.flag}</span>
            {lang.name}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown>
  );
};

export default LanguageSwitcher;
